<template>
  <v-navigation-drawer
    :permanent="true"
    dark
    width="250"
    style="position: fixed; min-height: 100vh; background: #43425D"
    :mini-variant="shouldToggle || currentPageWidth < 1200">
    <v-toolbar dark style="height: 63px; border-bottom: 1px solid #4a4a4a; background: #43425D;"
               class="display-flex justify-content-center">
      <v-toolbar-title>
        <router-link style="text-decoration: none; color: white;" :to="{name: 'Vouchers'}">
          {{shouldToggle || 1200>currentPageWidth ? 'BD' : 'Blue Diamond'}}
        </router-link>
      </v-toolbar-title>
    </v-toolbar>

    <v-list class="pt-0 mt-3" dense>
      <router-link :to="{name:'Vouchers'}" active-class="active" tag="li" class="display-flex pt-1 pb-1"
                   style="cursor: pointer"
      >
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>fas fa-gem</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Vouchery</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
    </v-list>

    <v-list class="pt-0 mt-3" dense>
      <router-link :to="{name:'DebitNotes'}" active-class="active" exact tag="li" class="display-flex pt-1 pb-1"
                   style="cursor: pointer"
      >
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>fas fa-file-invoice-dollar</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Noty obciążeniowe</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
    </v-list>

    <v-list class="pt-0 mt-3" dense>
      <router-link :to="{name:'Tickets'}" active-class="active" exact tag="li" class="display-flex pt-1 pb-1"
                   style="cursor: pointer"
      >
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>fas fa-ticket-alt</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Karnety</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
    </v-list>

    <v-list class="pt-0 mt-3" dense v-permissions>
      <router-link :to="{name:'Users'}" active-class="active" exact tag="li" class="display-flex pt-1 pb-1"
                   style="cursor: pointer"
      >
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>fas fa-users</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Użytkownicy</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
    </v-list>

    <v-list class="pt-0 mt-3" dense v-permissions>
      <router-link :to="{name:'VoucherTypes'}" active-class="active" exact tag="li" class="display-flex pt-1 pb-1"
                   style="cursor: pointer"
      >
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>fas fa-cog</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Nazwy voucherów</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </router-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  /* eslint-disable prefer-const */

  export default {
    name: 'AppSidebar',
    props: {
      shouldToggle: Boolean,
      currentPageWidth: Number,
    },
    data() {
      return {
        drawer: true,
        currentLang: 'PL',
      };
    },
    methods: {
      changeLang(lang) {
        this.currentLang = lang;
      },
    },
  };
</script>

<style scoped>
  .active {
    background-color: #3B3B53;
    cursor: pointer;
  }
</style>
